module.exports = __webpack_public_path__ + "static/media/seeds-of-change-mobile.a283c9f9.jpg";